import React from "react";
import EnhancedImageButton from "./EnhancedImageButton";
import VoiceInputButton from "./VoiceInputButton";

const Button = ({
  editor,
  onClick,
  command,
  commandData,
  label,
  disabled,
  caption,
}) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
      className={
        "tip-button " +
        (command
          ? editor.isActive(command, commandData)
            ? "tip-is-active"
            : ""
          : "")
      }
      disabled={disabled}
      title={caption}
      tabIndex="0"
    >
      {label}
    </button>
  );
};

const MenuBar = ({
  editor,
  addImage,
  setLink,
  minimalEditor,
  createMPSLink,
  mention,
  isRecording,
  isInitializing,
  onToggleRecording,
}) => {
  if (!editor) {
    return null;
  }

  return (
    <div className="mb-3">
      <div>
        {!minimalEditor && (
          <Button
            command="paragraph"
            editor={editor}
            label="Paragraph"
            onClick={() => editor.chain().focus().setParagraph().run()}
          />
        )}

        <Button
          editor={editor}
          label={<i className="fa fa-bold" />}
          command="bold"
          onClick={() => editor.chain().focus().toggleBold().run()}
        />
        <Button
          editor={editor}
          label={<i className="fa fa-italic" />}
          command="italic"
          onClick={() => editor.chain().focus().toggleItalic().run()}
        />

        <Button
          editor={editor}
          onClick={() => editor.chain().focus().toggleStrike().run()}
          command={"strike"}
          label={<i className="fa fa-strikethrough" />}
        />

        {!minimalEditor && (
          <Button
            editor={editor}
            label={<i className="fa fa-code" />}
            command="code"
            onClick={() => editor.chain().focus().toggleCode().run()}
          />
        )}

        {/*<button*/}
        {/*    onClick={() =>*/}
        {/*        editor*/}
        {/*            .chain()*/}
        {/*            .focus()*/}
        {/*            .clearNodes()*/}
        {/*            .run()*/}
        {/*    }*/}
        {/*    className="tip-button"*/}
        {/*>*/}
        {/*  clear nodes*/}
        {/*</button>*/}

        <Button
          command="heading"
          commandData={{ level: 1 }}
          editor={editor}
          label="H1"
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 1 }).run()
          }
        />

        <Button
          editor={editor}
          label="H2"
          command="heading"
          commandData={{ level: 2 }}
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 2 }).run()
          }
        />

        <Button
          editor={editor}
          label="H3"
          command="heading"
          commandData={{ level: 3 }}
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 3 }).run()
          }
        />
        <Button
          editor={editor}
          label="H4"
          command="heading"
          commandData={{ level: 4 }}
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 4 }).run()
          }
        />

        <Button
          editor={editor}
          label="H5"
          command="heading"
          commandData={{ level: 5 }}
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 5 }).run()
          }
        />

        <Button
          editor={editor}
          label="H6"
          command="heading"
          commandData={{ level: 6 }}
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 6 }).run()
          }
        />

        <Button
          editor={editor}
          label={<i className="fa fa-subscript" />}
          command="subscript"
          onClick={() => editor.chain().focus().toggleSubscript().run()}
          className={editor.isActive("subscript") ? "is-active" : ""}
        />

        <Button
          editor={editor}
          label={<i className="fa fa-superscript" />}
          command="superscript"
          onClick={() => editor.chain().focus().toggleSuperscript().run()}
        />

        <Button
          editor={editor}
          label={<i className="fa fa-list-ul" />}
          command="bulletList"
          onClick={() => editor.chain().focus().toggleBulletList().run()}
        />
        <Button
          editor={editor}
          label={<i className="fa fa-list-ol" />}
          command="orderedList"
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
        />

        {!minimalEditor && (
          <Button
            editor={editor}
            label={<i className="fa fa-code" />}
            command="codeBlock"
            onClick={() => editor.chain().focus().toggleCodeBlock().run()}
          />
        )}

        {!minimalEditor && (
          <Button
            editor={editor}
            label={<i className="fa fa-quote-left" />}
            command="blockquote"
            onClick={() => editor.chain().focus().toggleBlockquote().run()}
          />
        )}

        {!minimalEditor && (
          <Button
            editor={editor}
            label={<i className="fa fa-undo" />}
            command="undo"
            onClick={() => editor.chain().focus().undo().run()}
          />
        )}

        {!minimalEditor && (
          <Button
            editor={editor}
            label={<i className="fa fa-redo" />}
            command="redo"
            onClick={() => editor.chain().focus().redo().run()}
          />
        )}

        <EnhancedImageButton editor={editor} />

        <Button
          editor={editor}
          label={<i className="fa fa-link" />}
          command="link"
          onClick={setLink}
          className={editor.isActive("link") ? "is-active" : ""}
        />
        <Button
          editor={editor}
          label={
            <span>
              MPS <i className="fa fa-link" />
            </span>
          }
          command="embedLink"
          className={editor.isActive("mpsLink") ? "is-active" : ""}
          onClick={createMPSLink}
        />
        {!minimalEditor && (
          <Button
            editor={editor}
            label={
              <span>
                Remove <i className="fa fa-link" />
              </span>
            }
            onClick={() => editor.chain().focus().unsetLink().run()}
            disabled={!editor.isActive("link")}
          />
        )}

        <Button
          editor={editor}
          command="highlight"
          label={<i className="fa fa-text-height" />}
          onClick={() => editor.chain().focus().toggleHighlight().run()}
        />

        <input
          tabIndex="0"
          className="tip-input"
          type="color"
          onInput={(event) =>
            editor.chain().focus().setColor(event.target.value).run()
          }
          value={editor.getAttributes("textStyle").color}
        />

        <select
          tabIndex="0"
          className="tip-select"
          onChange={(event) => {
            editor.chain().focus().setFontSize(event.target.value).run();
          }}
          value={editor.getAttributes("textStyle").fontSize}
        >
          <option value={""}>Size</option>
          <option value="10px">10px</option>
          <option value="11px">11px</option>
          <option value="12px">12px</option>
          <option value="13px">13px</option>
          <option value="14px">14px</option>
          <option value="16px">16px</option>
          <option value="18px">18px</option>
          <option value="20px">20px</option>
          <option value="22px">22px</option>
          <option value="24px">24px</option>
          <option value="30px">30px</option>
        </select>

        <Button
          editor={editor}
          label={<i className="fa fa-align-left" />}
          command={{ textAlign: "left" }}
          onClick={() => editor.chain().focus().setTextAlign("left").run()}
        />

        <Button
          editor={editor}
          label={<i className="fa fa-align-center" />}
          command={{ textAlign: "center" }}
          onClick={() => editor.chain().focus().setTextAlign("center").run()}
        />

        <Button
          editor={editor}
          label={<i className="fa fa-align-right" />}
          command={{ textAlign: "right" }}
          onClick={() => editor.chain().focus().setTextAlign("right").run()}
        />
        <Button
          editor={editor}
          label={<i className="fa fa-align-justify" />}
          command={{ textAlign: "justify" }}
          onClick={() => editor.chain().focus().setTextAlign("justify").run()}
        />

        {/*<button*/}
        {/*  className="tip-button"*/}
        {/*  onClick={() =>*/}
        {/*    editor*/}
        {/*      .chain()*/}
        {/*      .focus()*/}
        {/*      .unsetTextAlign()*/}
        {/*      .run()*/}
        {/*  }*/}
        {/*>*/}
        {/*  Remove Align*/}
        {/*</button>*/}

        {!minimalEditor && (
          <Button
            editor={editor}
            // label="Inline Section"
            label={<i className="fa fa-box" />}
            caption="Section for inline image and text"
            command="inlineSection"
            onClick={() => editor.chain().focus().setInlineSection().run()}
          />
        )}

        {!minimalEditor && (
          <Button
            editor={editor}
            label="Line"
            command="blockquote"
            onClick={() => editor.chain().focus().setHorizontalRule().run()}
          />
        )}

        <Button
          editor={editor}
          label="Break"
          command="hardBreak"
          onClick={() => editor.chain().focus().setHardBreak().run()}
        />
        <Button
          editor={editor}
          label={<i className="fa fa-at" />}
          command="mention"
          onClick={mention}
        />
        {!minimalEditor && (
          <Button
            label="Clear Styles"
            onClick={() => editor.chain().focus().unsetAllMarks().run()}
          />
        )}
        {onToggleRecording && (
          <VoiceInputButton
            isRecording={isRecording}
            isInitializing={isInitializing}
            onToggle={onToggleRecording}
          />
        )}
      </div>

      <div className="mt-2">
        {!minimalEditor && (
          <Button
            editor={editor}
            label={<i className="fa fa-table" />}
            command="table"
            onClick={() =>
              editor
                .chain()
                .focus()
                .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
                .run()
            }
          />
        )}

        {editor.isActive("table") && (
          <React.Fragment>
            <Button
              editor={editor}
              label={
                <span>
                  <i className="fa fa-plus mr-1" />
                  Col
                </span>
              }
              onClick={() => editor.chain().focus().addColumnBefore().run()}
              disabled={!editor.can().addColumnBefore()}
            />
            <Button
              editor={editor}
              label={
                <span>
                  Col
                  <i className="fa fa-plus ml-1" />
                </span>
              }
              onClick={() => editor.chain().focus().addColumnAfter().run()}
              disabled={!editor.can().addColumnAfter()}
            />
            <Button
              editor={editor}
              label={
                <span>
                  <i className="fa fa-minus mr-1" />
                  Col
                </span>
              }
              onClick={() => editor.chain().focus().deleteColumn().run()}
              disabled={!editor.can().deleteColumn()}
            />
            <Button
              editor={editor}
              label={
                <span>
                  <i className="fa fa-plus mr-1" />
                  Row
                </span>
              }
              onClick={() => editor.chain().focus().addRowBefore().run()}
              disabled={!editor.can().addRowBefore()}
            />
            <Button
              editor={editor}
              label={
                <span>
                  Row
                  <i className="fa fa-plus ml-1" />
                </span>
              }
              onClick={() => editor.chain().focus().addRowAfter().run()}
              disabled={!editor.can().addRowAfter()}
            />
            <Button
              editor={editor}
              label={
                <span>
                  <i className="fa fa-minus mr-1" />
                  Row
                </span>
              }
              onClick={() => editor.chain().focus().deleteRow().run()}
              disabled={!editor.can().deleteRow()}
            />
            <Button
              editor={editor}
              label={
                <span>
                  <i className="fa fa-minus mr-1" />
                  Table
                </span>
              }
              onClick={() => editor.chain().focus().deleteTable().run()}
              disabled={!editor.can().deleteTable()}
            />
            {/*<Button*/}
            {/*  editor={editor}*/}
            {/*  label="Merge"*/}
            {/*  onClick={() =>*/}
            {/*    editor*/}
            {/*      .chain()*/}
            {/*      .focus()*/}
            {/*      .mergeCells()*/}
            {/*      .run()*/}
            {/*  }*/}
            {/*  disabled={!editor.can().mergeCells()}*/}
            {/*/>*/}
            {/*<Button*/}
            {/*  editor={editor}*/}
            {/*  label="Split"*/}
            {/*  onClick={() =>*/}
            {/*    editor*/}
            {/*      .chain()*/}
            {/*      .focus()*/}
            {/*      .splitCell()*/}
            {/*      .run()*/}
            {/*  }*/}
            {/*  disabled={!editor.can().splitCell()}*/}
            {/*/>*/}
            <Button
              editor={editor}
              label="Merge/Split"
              onClick={() => editor.chain().focus().mergeOrSplit().run()}
              disabled={!editor.can().mergeOrSplit()}
            />

            <Button
              editor={editor}
              label="Col Header"
              onClick={() => editor.chain().focus().toggleHeaderColumn().run()}
              disabled={!editor.can().toggleHeaderColumn()}
            />

            <Button
              editor={editor}
              label="Row Header"
              onClick={() => editor.chain().focus().toggleHeaderRow().run()}
              disabled={!editor.can().toggleHeaderRow()}
            />

            <Button
              editor={editor}
              label="Cell Header"
              onClick={() => editor.chain().focus().toggleHeaderCell().run()}
              disabled={!editor.can().toggleHeaderCell()}
            />

            {/*<button*/}
            {/*  onClick={() =>*/}
            {/*    editor*/}
            {/*      .chain()*/}
            {/*      .focus()*/}
            {/*      .setCellAttribute("backgroundColor", "#FAF594")*/}
            {/*      .run()*/}
            {/*  }*/}
            {/*  disabled={*/}
            {/*    !editor.can().setCellAttribute("backgroundColor", "#FAF594")*/}
            {/*  }*/}
            {/*>*/}
            {/*  setCellAttribute*/}
            {/*</button>*/}
          </React.Fragment>
        )}

        {/*<button*/}
        {/*  onClick={() =>*/}
        {/*    editor*/}
        {/*      .chain()*/}
        {/*      .focus()*/}
        {/*      .fixTables()*/}
        {/*      .run()*/}
        {/*  }*/}
        {/*  disabled={!editor.can().fixTables()}*/}
        {/*>*/}
        {/*  fixTables*/}
        {/*</button>*/}
        {/*<button*/}
        {/*  onClick={() =>*/}
        {/*    editor*/}
        {/*      .chain()*/}
        {/*      .focus()*/}
        {/*      .goToNextCell()*/}
        {/*      .run()*/}
        {/*  }*/}
        {/*  disabled={!editor.can().goToNextCell()}*/}
        {/*>*/}
        {/*  goToNextCell*/}
        {/*</button>*/}
        {/*<button*/}
        {/*  onClick={() =>*/}
        {/*    editor*/}
        {/*      .chain()*/}
        {/*      .focus()*/}
        {/*      .goToPreviousCell()*/}
        {/*      .run()*/}
        {/*  }*/}
        {/*  disabled={!editor.can().goToPreviousCell()}*/}
        {/*>*/}
        {/*  goToPreviousCell*/}
        {/*</button>*/}
      </div>
    </div>
  );
};

export default MenuBar;
